import React, { Component } from 'react';

export class ScheduleRow extends Component {
  constructor(props) {
    super(props);
      this.nflMatchup = props.nflMatchup;
      this.state = { loading: true };
  }

  componentDidMount() {
    this.populateRow();
    }

  

      renderNflMatchup(nflMatchup) {
    return (
        <div>
            <div className="row nflMatchupRow">
                <input type="hidden" className="matchBox" name={nflMatchup.matchupId} defaultValue={nflMatchup.matchupId}/>
                <div className="col-sm-3 nflMatchupRow">
                   {nflMatchup.awayTeam}
                </div>
                <div className="col-sm-1 nflMatchupRow">
                    <input type="number" className="matchBox" name={nflMatchup.awayId} defaultValue={nflMatchup.awayScore}/>
                    
                </div>
                <div className="col-sm-3 nflMatchupRow">
                {nflMatchup.homeTeam}
                </div>
                <div className="col-sm-1 nflMatchupRow">
                    <input type="number" className="matchBox" name={nflMatchup.homeId} defaultValue={nflMatchup.homeScore} />
                </div>
        </div>
        </div>
    );
}
  

  render() {
    let contents = this.state.loading
      ? <p><em>Loading...</em></p>
      : this.renderNflMatchup(this.nflMatchup,this.handleChange);

    return (
      <div>
        {contents}
      </div>
    );
  }

  async populateRow(data) {
     this.setState({ loading: false });
    }
}
